import { TimezoneDate } from './timezone-date';

/**
 * currently we store tenant timezoneOffset, but it is not correct because offset changes over the year (daylight)
 * sometime we will change it and get ianaTimezoneCode from db, but now we have to calculate it manually
 *
 * @param timezoneOffset
 */
export const getTimezoneCode = (timezoneOffset?: number): string => {
    const timezones = [
        'America/New_York',
        'America/Chicago',
        'America/Chihuahua',
        'America/Los_Angeles',
    ];

    if (!timezoneOffset) {
        return timezones[0];
    }

    for (const tz of timezones) {
        if (timezoneOffset === TimezoneDate.getOffsetFromTimezone(tz)) {
            return tz;
        }
    }

    return timezones[0];
};
